/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import FlatList from 'flatlist-react';
import { Row, Col, Nav } from 'react-bootstrap';
// import { AppCard, IAppCardList } from "@vlinder-web/app-card-widget-react";
import { AppCard, IAppCardList } from '@/widgets/app-card-widget-react';
import {
  StateOSD,
  IStateOSDProps,
} from '@vlinder-web/state-osd-v2-widget-react';

import { useTheme } from '@/providers/theme';

import * as S from './styles';

export interface IAppCardListCompProps {
  appCardList: IAppCardList[];
  appCardGridRow?: {
    xs: 1 | 2 | 3 | 4;
    md: 1 | 2 | 3 | 4;
    lg: 1 | 2 | 3 | 4;
  };
  onCardClick?(id: string): void;
  totalCount: number;
  totalPages: number;
  activePage: number;
  onPageChange?(page: number): void;
  emptyListProps?: IStateOSDProps;
}

export const AppCardListComp = ({
  appCardList,
  appCardGridRow,
  onCardClick,
  emptyListProps,
}: IAppCardListCompProps) => {
  const theme = useTheme();
  const _renderItem = (appCard: any, index: number) => {
    return (
      <Col
        key={`app-card-col-${index}`}
        xs={appCardGridRow?.xs ? 12 / appCardGridRow?.xs : 12}
        md={appCardGridRow?.md ? 12 / appCardGridRow?.md : 6}
        lg={appCardGridRow?.lg ? 12 / appCardGridRow?.lg : 4}
        style={S.CardContainerStyle}
        onClick={() => onCardClick && onCardClick(appCard)}
      >
        <AppCard
          {...(appCard || { id: index })}
          hoverColor={theme?.colors?.orangeSecondary}
        />
      </Col>
    );
  };
  return (
    <>
      <Row>
        <FlatList
          list={appCardList}
          renderItem={_renderItem}
          renderWhenEmpty={() => <StateOSD {...(emptyListProps || {})} />}
        />
      </Row>
    </>
  );
};

AppCardListComp.defaultProps = {
  appCardList: [],
};
